/**
 * A publisher for tracking a centralized global countdown (e.g. user is checking out)
 * @namespace Countdown
 * @augments Publisher
 */
define("Countdown", [`Publisher`, `module`], (Super, Self) =>
	Super.inherit({
		namespace: Self.id,
		singleton: true,
		prepare(setup) {
			const expiration = null;

			// set the initial internal value
			this.update({ expiration });
		},
		api: {
			/**
			 * @method Countdown#setExpiration
			 */
			setExpiration: {
				public: true,
				value(context, expiration) {
					this.update({ expiration });
				},
			},
			/**
			 * @method Countdown#clearExpiration
			 */
			clearExpiration: {
				public: true,
				value(context) {
					this.update({ expiration: null });
				},
			},
		},
	}));

//# sourceMappingURL=Countdown.js.map